
Checkout.Cart.Totals = function(checkout, cart) {
	var totals = this;

	this.values = {
		'subtotal': '0.00',
		'subtotalTaxable': '0.00',
		'origShipping': '0.00',
		'shipping': '0.00',
		'originalShippingRetail': '0.00',
		'origTax': '0.00',
		'tax': '0.00',
		'fees': {},
		'total': '0.00',
		'balances': {},
		'remaining': '0.00'
	};

	this.taxRate = 0;
	this.taxValue = 0;

	this.$wrap = $('#scarttotals');
	this.$loadingOverlay = $('#cart-totals-overlay');
	this.$loadingMsg = this.$loadingOverlay.find('.msg-text');
	this.$subtotal = $('#cart-subtotal');
	this.$shipping = $('#cart-shipping');
	this.$shippingOverrideWrap = $('#cart-shipping-override-wrap');
	this.$shippingOverride = $('#cart-shipping-override');
	this.$taxWrap = $('#cart-tax-wrap');
	this.$tax = $('#cart-tax');
	this.$taxExemptWrap = $('#cart-tax-exempt-wrap');
	this.$taxExempt = $('#cart-tax-exempt');
	this.$totalWrap = $('#cart-total-wrap');
	this.$total = $('#cart-total');
	this.$remainingWrap = $('#cart-remaining-wrap');
	this.$remaining = $('#cart-remaining');
	this.$cartNumItems = $('#cart-num-items');
	this.$textCart = $("#textcart");
	this.elementType = checkout.config.isEndeca ? 'span' : 'label';

	this.init = function() {
		totals.listen();

		if (
			checkout.user
			&& checkout.session.get('taxExempt')
		)
			totals.$taxExempt.prop('checked', true);
	};

	this.listen = function() {
		totals.$taxExempt.change(totals.changeTaxExempt);
	};

	this.calc = function(force) {
		totals.updateNumItems();
		cart.shipping.calc(force);
	};

	this.updateNumItems = function() {
		var numItems = 0;

		for (var cartItemKey in cart.items)
			numItems += parseInt(cart.items[cartItemKey].data.qty);

		totals.$cartNumItems
			.html('<i class="icon-white icon-shopping-cart"></i> <b>My Cart: </b> <span class="cartCount">'+ numItems +'</span>')
			.attr('title', 'You have '+numItems+' item(s) in your cart');

		$(checkout.cartItemCount).text(numItems); // update the header shopping cart badge
		
	};

	this.update = async function(stepChanged) {
		var subtotal = 0.00,
			subtotalTaxable = 0.00,
			shipping = cart.shipping.total,
			originalShippingRetail = cart.shipping.originalShippingRetail,
			tax = 0.00,
			fees = 0.00,
			remaining = 0.00;

		var origTax;

		for (var cartItemKey in cart.items) {
			var item = cart.items[cartItemKey];

			subtotal += (item.data.qty * item.unitprice);

			if (!parseInt(item.data.taxExempt))
				subtotalTaxable += (item.data.qty * item.unitprice);
		}

		totals.values.origShipping = shipping.toMoney();

		if (
			checkout.user
			&& checkout.session.get('shippingOverride')
		)
			shipping = (parseFloat(checkout.session.get('shippingOverrideAmt')) || 0);

		totals.values.origTax = '0.00';
		origTax = 0;

        var taxCalc = () => {
            return new Promise( ( resolve, reject ) => {
                checkout.remote
                    .call( {
                        'url'  : "/taxCalc/",
                        'data' : {
                            'shippingCost' : shipping,
                            'country'      : checkout.session.get( "shipping.country" ),
                            'zip'          : checkout.session.get( "shipping.zip" ),
                            'state'        : checkout.session.get( "shipping.state" )
                        }
                    } )
                    .done( ( response ) => {
                        if ( response.salesTax !== null ) {
                            resolve( response.salesTax );
                        }
                        else {
                            reject();
                        }
                    } )
                    .fail( () => {
                        reject();
                    } );
            } );
        };
        try {
            origTax = await taxCalc();
        }
        catch ( e ) {
            console.warn( "tax calc failed", e );
        }

        if (
            checkout.user
            && totals.$taxExempt.prop('checked')
        )
            tax = 0.00;
        else
            tax = origTax;
        
		totals.values.origTax = origTax.toMoney();

		totals.values.subtotal = subtotal.toMoney();
		totals.values.subtotalTaxable = subtotalTaxable.toMoney();
		totals.values.shipping = shipping.toMoney();
		totals.values.originalShippingRetail = originalShippingRetail.toMoney();
		totals.values.tax = tax.toMoney();

		var taxFloat = parseFloat(totals.values.tax);//Takes tax which is a string and converts it to floating point so it can be added

		for (var feeLabel in totals.values.fees)
			fees += parseFloat(totals.values.fees[feeLabel]);
		
		totals.values.total = (
			subtotal
			+ shipping
			+ taxFloat
			+ fees
		).toMoney();

		remaining = parseFloat(totals.values.total);

		for (var balanceLabel in totals.values.balances)
			remaining -= parseFloat(totals.values.balances[balanceLabel]);

		if (remaining < 0)
			remaining = 0;

		totals.values.remaining = remaining.toMoney();

		totals.buildContent();

		var valid = cart.validate();

		totals.loading(false, valid, stepChanged);

		if (valid) {

			if (checkout.session.get('step') == 'cart')
				cart.toggleStepControls();
			else if (!checkout.shipping)
				return cart.proceed();

		} else {

			checkout.session.set({
				'step': 'cart'
			});

			cart.$cShopping.show();

		}

		if (checkout.config.paypalError) {
			cart.error(checkout.paypalErrorMsg);
			checkout.config.paypalError = 0;
		}
		if (checkout.session.get('PayPalConfirmed') && !cart.shipping.$zip.val()) {
			cart.shipping.showValidateErrors( cart.shipping.getValidateErrors() )
		}

		this.updateNumItems(); // update the header shopping cart badge in case quatities have changed

	};

	this.buildContent = function() {
		totals.$subtotal.html( '$' + commaSeparate(totals.values.subtotal) );

		if ( checkout.config.isEndeca && ( !cart.shipping.$zip.val() || cart.shipping.getValidateErrors().length ) )
			totals.$shipping.html( 'Calculate Above' );
		else
			totals.$shipping.html( '$' + commaSeparate(totals.values.origShipping) );
		
		if ( checkout.config.isEndeca && ( !cart.shipping.$zip.val() || cart.shipping.getValidateErrors().length ) )
			totals.$shippingOverride.html( 'Calculate Above' );
		else
			totals.$shippingOverride.html( '$' + commaSeparate(totals.values.shipping) );

		if (totals.values.origShipping != totals.values.shipping) {
			totals.$shipping.css('text-decoration', 'line-through');
			totals.$shippingOverrideWrap.show();
		} else {
			totals.$shipping.css('text-decoration', '');
			totals.$shippingOverrideWrap.hide();
		}

		totals.$tax.html( commaSeparate(totals.values.origTax) );

		if (
			checkout.user
			&& totals.$taxExempt.prop('checked')
		)
			totals.$tax.css('text-decoration', 'line-through');
		else
			totals.$tax.css('text-decoration', '');

		totals.$total.html( '$' + commaSeparate(totals.values.total) );

		if (parseFloat(totals.values.origTax)) {

			totals.$taxWrap.show();

			if (checkout.user)
				totals.$taxExemptWrap.show();

		} else {
			totals.$taxWrap.hide();
			totals.$taxExemptWrap.hide();
		}

		totals.buildFees();
		totals.buildPaymentMethods();
	};

	this.buildFees = function() {
		var fees = [];

		for (var feeLabel in totals.values.fees)
			fees.push(
				'<div class="fee">'
					+ '<'+totals.elementType+'>' + feeLabel + ' Fee: </'+totals.elementType+'>'
					+ '<span>'
						+ parseFloat(totals.values.fees[feeLabel]).toMoney()
					+ '</span>'
				+ '</div>'
			);

		totals.$wrap
			.children('.fee')
			.remove();

		if (fees.length)
			totals.$totalWrap.before(fees);

	};

	this.buildPaymentMethods = function() {
		var values = totals.values,
			rows = [],
			displayRemaining = parseFloat(totals.values.remaining);

		if (checkout.payment) {

			$.each(checkout.payment.balanceMethods, function(i, method) {
				var balance = (parseFloat(values.balances[method.label]) || 0);

				if (balance)
					rows.push(
						'<div class="payment-summary">'
							+ '<'+totals.elementType+'>' + method.label + ': </'+totals.elementType+'>'
							+ '<span>'
								+ '-$' + commaSeparate(balance.toMoney())
							+ '</span>'
						+ '</div>'
					);
			});

			checkout.payment.$methodContainer.find('.payment-method:visible')
				.each(function(i, methodWrap) {
					var method = checkout.payment.methods[$(methodWrap).data('methodKey')],
						amt = checkout.payment.getMethodAmt(method);

					displayRemaining -= amt;

                    var method_label = method.label;
                    if (method.getStoredPaymentType && method.getStoredPaymentType().match(/paypal/))
                       method_label = 'PayPal';
					rows.push(
						'<div class="payment-summary">'
							+ '<'+totals.elementType+'>' + method_label + ': </'+totals.elementType+'>'
							+ '<span>'
								+ '-$' + commaSeparate(amt.toMoney())
							+ '</span>'
						+ '</div>'
					);

				});

		}

		totals.$wrap
			.children('.payment-summary')
			.remove();

		if (displayRemaining < 0)
			displayRemaining = 0;

		totals.$remaining.html('$' + displayRemaining.toMoney());

		if (rows.length) {
			totals.$totalWrap.after(rows.join("\n"));
			totals.$remainingWrap.show();
		} else
			totals.$remainingWrap.hide();

	};

	this.changeTaxExempt = function() {

		checkout.session.set({
			'taxExempt': (totals.$taxExempt.prop('checked') ? 1 : 0)
		});

		totals.update('payment');
	};

	this.loading = function(loadingMsg, loadSuccess, stepChanged) {
		if (loadingMsg) {

			cart.$wrap.trigger('loading', loadingMsg);

			$("#textcart").hide();
			totals.$loadingMsg.html(loadingMsg);
			totals.$loadingOverlay.show();
			checkout.alignMiddle(totals.$loadingOverlay.find('.msg'), totals.$loadingOverlay);

		} else {
			if (checkout.user)
				$("#textcart").show();
			totals.$loadingOverlay.hide();

			$('body').addClass('doneLoading');

			if (loadSuccess)
				cart.$wrap.trigger('loadDone', stepChanged);
			else
				cart.$wrap.trigger('loadFail');
		}
	};

	this.init();
};

